import { IdTutorialStep } from "../../IdTutorialStep";
export var checkTutorialPurchaseBuilding = function (path) { return function (action, state$, dependencies) {
    if (action.tutorialStep === IdTutorialStep.constructWindmill_confirmPlacement) {
        return path;
    }
    return undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/tutorial/restore/checks/checkTutorialPurchaseBuilding.ts
// module id = 2470
// module chunks = 3